import axios from "axios";
import { params, header, scopeListAPI } from "../_api";

import {
  FETCH_SCOPE_LIST_SUCCESS,
  FETCH_SCOPE_LIST_FAILURE,
  EDIT_SCOPE_LIST_SUCCESS,
  EDIT_SCOPE_LIST_FAILURE,
  DELETE_SCOPED_FINDING_SUCCESS,
  DELETE_SCOPED_FINDING_FAILURE,
  FETCH_SCOPE_LIST_REQUEST
} from "../_constants";

const fetchScopeListRequest = () => {
  return { type: FETCH_SCOPE_LIST_REQUEST };
};

const fetchScopeListSuccess = (data) => {
  return { type: FETCH_SCOPE_LIST_SUCCESS, payload: data };
};

const fetchScopeListFailure = (error) => {
  return { type: FETCH_SCOPE_LIST_FAILURE, payload: error };
};

export const fetchScopeList = (findingRuleID, scope,machine_type,hmi_type) => {
  return async (dispatch) => {
    dispatch(fetchScopeListRequest())
    return axios({
      method: "get",
      url: scopeListAPI,
      params: {
        ...params,
        finding_rule_id: findingRuleID,
        machine_type:machine_type,
        hmi_type:hmi_type,
        scope: scope,
        userid: sessionStorage.getItem('userId')
      },
      headers: header,
    })
      .then((response) => {
        dispatch(fetchScopeListSuccess(response.data));
      })
      .catch((error) => {
        const errorMsg = error.response.data.message;
        dispatch(fetchScopeListFailure(errorMsg));
      });
  };
};

const editScopeListSuccess = (data) => {
  return { type: EDIT_SCOPE_LIST_SUCCESS, payload: data };
};

const editScopeListFailure = (error) => {
  return { type: EDIT_SCOPE_LIST_FAILURE, payload: error };
};

export const editScopeList = (findingRuleID, scope, note_text, machine_type,hmi_type) => {
  return async (dispatch) => {
    return axios({
      method: "put",
      url: scopeListAPI,
      params: {
        ...params,
        machine_type: machine_type,
        hmi_type:hmi_type,
        userid: sessionStorage.getItem('userId')
      },
      headers: header,
      data: {
        finding_rule_id: findingRuleID,
        scope: scope,
        note_text: note_text,
        operation_eq: null,
      },
    })
      .then((response) => {
        dispatch(editScopeListSuccess(response.data));
      })
      .catch((error) => {
        const errorMsg = error.response.data.message;
        dispatch(editScopeListFailure(errorMsg));
      });
  };
};

const deleteScopeFindingSuccess = (data) => {
  return { type: DELETE_SCOPED_FINDING_SUCCESS, payload: data };
};

const deleteScopeFindingFailure = (error) => {
  return { type: DELETE_SCOPED_FINDING_FAILURE, payload: error };
};

export const deleteScopedFinding = (findingRuleID, scope , machine_type,hmi_type) => {
  return async (dispatch) => {
    return axios({
      method: "delete",
      url: scopeListAPI,
      params: {
        ...params,
        finding_rule_id: findingRuleID,
        scope: scope,
        machine_type:machine_type,
        hmi_type:hmi_type,
        userid: sessionStorage.getItem('userId')
      },
      headers: header,
    })
      .then((response) => {
        dispatch(deleteScopeFindingSuccess(response.data));
      })
      .catch((error) => {
        const errorMsg = error.response.data.message;
        dispatch(deleteScopeFindingFailure(errorMsg));
      });
  };
};
